import OpenTable from '../../../images/OpenTable.png';

export const OpenTableIcon = () => (
  <div className="order-res-links-icon">
    <img src={OpenTable} alt="OpenTable" />
  </div>
);

export default OpenTableIcon;
